import { PortfolioDetail_s } from 'components/asset-management/reports/report-styles'
import DataTable_s from 'components/table/data-table-styles'
// Data
import { alphanum } from "components/table/lib/sort"
import api_match from "data/interface/api"
import portfolioService from "data/portfolio"
import propertyReportService from "data/reports-property"
import _ from 'lodash'
// Components
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

const PortfolioDetail: FC = () => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [portfolios, setPortfolios] = useState<object[]|null>(null);

  useEffect(() => {
    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setPortfolios(ok.value.filter(p => _.get(p, "code") !== "*AllProperties").sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {  
            setPortfolios(ok.value.filter(p => _.get(p, "code") !== "*AllProperties"))
          }
        },
        err   => {
          setPortfolios(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    portfolioService.fetchPortfolios()

    return function cleanup() {
      portfolioSubscription.unsubscribe()
    }
  }, [initSort])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'portfolio_detail',
      params: {
        portfolios: data?.map(portfolio => portfolio['portfolioid'])
      }
    });
  }

  return (
    <PortfolioDetail_s>
      <ReportForm_s>
        <ButtonWithPress_s primary onClick={() => submit()}>Run Report</ButtonWithPress_s>
        <div>
          <Label_s>Select Portfolios</Label_s>
          <DataTable_s>
            <DataTable
              value={portfolios || undefined}
              paginator={true}
              rows={20}
              rowsPerPageOptions={[10, 20, 50, 100, 500]}
              emptyMessage="No records found"
              selection={data}
              onSelectionChange={(e)=>setData(e.value)}
            >
              <Column selectionMode="multiple" style={{width: '20px'}} />
              <Column field="code" header="Code" filter filterMatchMode="contains" sortable={true} style={{width: '150px'}} />
              <Column field="name" header="Name" filter filterMatchMode="contains" sortable={true} style={{width: '150px'}} />
            </DataTable>
          </DataTable_s>
        </div>
      </ReportForm_s>
    </PortfolioDetail_s>
  )
}

export default PortfolioDetail
